import gql from 'graphql-tag';

export default gql`
  {
    getPracticalInfo {
      id
      header_desktop
      header_mobile
      visual_desktop
      visual_mobile
      push_bg_desktop
      push_bg_mobile
      access_desktop
      access_mobile
      tt_hours
      tt_all_days
      tt_text_open
      tt_text_close
      detail {
        title
        opening
        closing_time
        section_instagram_title
      }
      services {
        picto
        detail {
          name
          cta_label
          cta_url
        }
      }
      parkings {
        picto
        detail {
          name
          phone
          content
          cta_label
          cta_url
        }
      }
      accesses {
        picto
        detail {
          title
          description
          cta_label
          cta_url
        }
      }
    }
  }
`;
